// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"79317bfe","455":"d1bcfa4e","977":"7f7f094c"}[chunkId] + ".chunk.js";
};